/** Chemins de navigation de l'objet Offre (mécanique de fiche par objet sur route). */

/** Base de la page "Configuration des offres commerciales". */
export const OFFER_ADMIN_BASE = '/admin/offres';

/** Onglet du dashboard correspondant au listing des offres. */
export const OFFER_TAB = 'offre';

/** Listing des offres (onglet du dashboard). */
export const offerListPath = `${OFFER_ADMIN_BASE}?tab=${OFFER_TAB}`;

/** Fiche de création d'une offre. */
export const offerCreatePath = `${OFFER_ADMIN_BASE}/offre/new`;

/** Fiche d'édition d'une offre. */
export const offerFichePath = (id: string | number): string => `${OFFER_ADMIN_BASE}/offre/${id}`;

/** Route enfant (relative à `admin/offres`) gérant création (`new`) et édition (`:id`). */
export const OFFER_FICHE_ROUTE = 'offre/:id';
